export default __webpack_public_path__ + "static/ryan-dce73e8e54f7cfe6e5dfc6b7633de49d.png";